import { render, staticRenderFns } from "./ChatPool.vue?vue&type=template&id=2594ba37&scoped=true"
import script from "./ChatPool.vue?vue&type=script&lang=js"
export * from "./ChatPool.vue?vue&type=script&lang=js"
import style0 from "./ChatPool.vue?vue&type=style&index=0&id=2594ba37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594ba37",
  null
  
)

export default component.exports